var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 18H109.84C113.127 18 116.271 19.349 118.537 21.7318L154.697 59.767C156.818 61.9976 158 64.9576 158 68.0353V170C158 176.627 152.627 182 146 182H54C47.3726 182 42 176.627 42 170V36.04",
    stroke: "#1B1B1B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 104.5H132V101.5H66V104.5ZM66 124.491H113.85V121.491H66V124.491Z",
    fill: "#59BD39"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContent);
export default ForwardRef;